import React, { useContext, useState, useEffect } from 'react';
import './header.css';
import { header, header_ing } from '../../json/header';
import { LanguageContext } from '../../context/LanguageContext/LanguageContext';

const Header = () => {
    const { language, toggleLanguage } = useContext(LanguageContext);
    const [activeIndex, setActiveIndex] = useState(0);
    const [activeSubmenu, setActiveSubmenu] = useState(-1);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isMenuOpen, setIsMenuOpen] = useState(false); // Estado para el menú hamburguesa

    const menuItems = language === 'ES' ? header : header_ing;

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const currentPath = window.location.pathname;

        const currentIndex = menuItems.findIndex(item => {
            if (item.link === currentPath) return true;
            if (item.submenu) {
                return item.submenu.some(subItem => subItem.link === currentPath);
            }
            return false;
        });

        if (currentIndex !== -1) {
            setActiveIndex(currentIndex);
        }
    }, [menuItems]);

    const handleItemClick = (index, hasSubmenu) => {
        if (isMobile && hasSubmenu) {
            // En móviles, alterna el submenú al hacer clic
            setActiveSubmenu(activeSubmenu === index ? -1 : index);
        } else if (!isMobile) {
            // En escritorio, sigue la navegación normal
            setActiveIndex(index);
            setActiveSubmenu(-1);
        }
    };

    const handleMouseEnter = (index) => {
        if (!isMobile) {
            setActiveSubmenu(index);
        }
    };

    const handleMouseLeave = () => {
        if (!isMobile) {
            setActiveSubmenu(-1);
        }
    };

    return (
        <nav className="navbar navbar-expand-lg header-hisol">
            <div className="container-fluid content-fixed">
                <a className="navbar-brand" href="/">
                    <div
                        className="header-logo"
                        style={{ backgroundImage: "url('/assets/imgs/header/Logo-Hisol.svg')" }} />
                </a>
                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={() => setIsMenuOpen(!isMenuOpen)} // Alternar el estado del menú
                    aria-controls="navbarNav"
                    aria-expanded={isMenuOpen}
                    aria-label="Toggle navigation"
                >
                    <div className="hamburger-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </button>
                <div className={`navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
                    <ul className="navbar-nav">
                        {menuItems.map((item, index) => (
                            <li
                                className={`nav-item ${activeIndex === index ? 'active' : ''}`}
                                key={index}
                                onMouseEnter={() => handleMouseEnter(index)}
                                onMouseLeave={handleMouseLeave}
                            >
                                <a
                                    className="nav-link"
                                    href={!isMobile && item.submenu ? '#' : item.link}
                                    onClick={(e) => {
                                        if (isMobile && item.submenu) {
                                            e.preventDefault();
                                        }
                                        handleItemClick(index, item.submenu);
                                    }}
                                >
                                    {language === 'ES' ? item.nombre : item.name}
                                </a>
                                {item.submenu && activeSubmenu === index && (
                                    <div className="submenu-container">
                                        {item.submenu.map((subItem, subIndex) => {
                                            const subItemClass = (subItem.nombre || subItem.name || '').toLowerCase();
                                            return (
                                                <a
                                                    href={subItem.link}
                                                    className={`submenu-item ${subItemClass} ${window.location.pathname === subItem.link ? 'active' : ''
                                                        }`}
                                                    key={subIndex}
                                                >
                                                    {language === 'ES' ? subItem.nombre : subItem.name}
                                                </a>
                                            );
                                        })}
                                    </div>
                                )}

                            </li>
                        ))}
                    </ul>

                </div>
                {/* <div className="lenguage">
                    <button className="btn btn-sm" onClick={toggleLanguage}>
                        {language === 'ES' ? 'EN' : 'ES'}
                    </button>
                </div> */}
            </div>
        </nav>
    );
};
export default Header
